import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'block',
    padding: 0,
    color: theme.palette.text.primary,
    fontFamily:
      "SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace",
    fontSize: 14,
    lineHeight: 1.7,
    whiteSpace: 'pre',
    backgroundColor: 'transparent'
  }
}));

export default function Code({ className, ...rest }) {
  const classes = useStyles();

  return (
    <code
      className={clsx(classes.root, className)}
      {...rest}
    />
  );
}

Code.propTypes = {
  className: PropTypes.string
};
